import { useParams, Link, useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { getDatastoreDetail } from "../../../../helpers/apis";
import { ComponentLoader } from "../../../../components/loader";
import { ArrowLeftIcon, ArrowRightIcon } from "@/assets/icons";
import styles from "../../styles.module.scss";
import SyncHistory from "./SyncHistory";
import Datastore from "./Datastore";
import { useAppState } from "@/modules/app/useAppContext";
import { PermissionsEnum } from "../../../../helpers/constants";
import { Stack } from "@altimateai/lego";
import { Typography } from "@altimateai/lego";
import { useBreadcrumb } from "@/components/breadcrumbs";

const GET_DATASTORE_DETAILS = "GET-DATASTORE-DETAILS";

const DatastoreDetails = (): JSX.Element => {
  const { datastoreId } = useParams<{ datastoreId: string }>();
  const navigate = useNavigate();
  const { loggedinUser: user } = useAppState();

  const { data: datastore, isLoading } = useQuery({
    queryKey: [GET_DATASTORE_DETAILS, datastoreId],
    queryFn: () => getDatastoreDetail(datastoreId!),
    enabled: !!datastoreId,
  });

  useBreadcrumb(datastore?.name ?? "Loading...", {
    defaultParents: [
      { label: "Settings", pathname: "/settings" },
      { label: "Connections", pathname: "/settings/datastores" },
    ],
  });

  if (isLoading) return <ComponentLoader left={60} label="Loading connection details..." />;

  if (!datastore) return <></>;

  return (
    <>
      <div className={styles.datastore_details}>
        <Stack align="center">
          <div className={styles.back_button} onClick={() => navigate(-1)}>
            <ArrowLeftIcon />
          </div>
          <Stack align="center" gap="sm" className={styles.customBreadcrumb}>
            <Link to="/settings/datastores" className="al-text-muted-foreground">
              <Typography variant="page-heading" className="al-text-muted-foreground">
                Connections
              </Typography>
            </Link>
            <ArrowRightIcon className={styles.breadcrumbIcon} />
            <Typography variant="page-heading">{datastore.name}</Typography>
          </Stack>
        </Stack>
        <Stack direction="column">
          <Datastore
            datastore={datastore}
            syncOpAllowed={Boolean(user?.permission?.includes(PermissionsEnum.DATASTORE_EDIT))}
          />
          <SyncHistory datastoreId={datastore.id.toString()} datastoreType={datastore.type} />
        </Stack>
      </div>
    </>
  );
};

export default DatastoreDetails;
